module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-white-bg-gold-300x300.653830d4.png";